const eventCategories = [
  "Comedy",
  "Miscellaneous",
  "Miscellaneous Theatre",
  "Performance Art",
  "Rodeo",
  "Family",
  "Concerts",
  "Dance/Electronic",
  "Hip-Hop/Rap",
  "Country",
  "Jazz",
  "Dance",
  "Classical Music",
  "Children's Theatre",
  "Theatre",
  "Sports",
  "Baseball",
  "Basketball",
  "Football",
  "Soccer"
];
eventCategories.sort();
module.exports = eventCategories;